/**
 * @generated SignedSource<<0a1c9479faaa2ea2930ceb6877350ce0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OneOnOneRefetchQuery$variables = {
  meetingId: string;
  userId: string;
  hasNoMeetingId: boolean;
};
export type OneOnOneRefetchQueryVariables = OneOnOneRefetchQuery$variables;
export type OneOnOneRefetchQuery$data = {
  readonly user: {
    readonly viewerUserRelationship: {
      readonly " $fragmentSpreads": FragmentRefs<"OneOnOne_checkinRelationship">;
    } | null;
  } | null;
};
export type OneOnOneRefetchQueryResponse = OneOnOneRefetchQuery$data;
export type OneOnOneRefetchQuery = {
  variables: OneOnOneRefetchQueryVariables;
  response: OneOnOneRefetchQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hasNoMeetingId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "meetingId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userId"
},
v3 = [
  {
    "kind": "Variable",
    "name": "entityId",
    "variableName": "userId"
  }
],
v4 = {
  "kind": "Variable",
  "name": "meetingId",
  "variableName": "meetingId"
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityId",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerIsUser",
  "storageKey": null
},
v8 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "preferredName",
    "storageKey": null
  },
  (v7/*: any*/),
  (v6/*: any*/),
  (v5/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "UserProducts",
    "kind": "LinkedField",
    "name": "products",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserProductSettings",
        "kind": "LinkedField",
        "name": "oneOnOnes",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isEnabled",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "scheduledAt",
  "storageKey": null
},
v10 = [
  (v6/*: any*/),
  (v5/*: any*/)
],
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "OneOnOneMeeting",
  "kind": "LinkedField",
  "name": "previousOneOnOneMeeting",
  "plural": false,
  "selections": (v10/*: any*/),
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "OneOnOneMeeting",
  "kind": "LinkedField",
  "name": "nextOneOnOneMeeting",
  "plural": false,
  "selections": (v10/*: any*/),
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cancelledAt",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "reviewedAt",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "note",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "reportNote",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerPrivateNote",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "body",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "avatarUrl",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "concreteType": "OneOnOneTalkingPoint",
  "kind": "LinkedField",
  "name": "talkingPoints",
  "plural": true,
  "selections": [
    (v5/*: any*/),
    (v18/*: any*/),
    (v6/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "creator",
      "plural": false,
      "selections": [
        (v19/*: any*/),
        (v20/*: any*/),
        (v7/*: any*/),
        (v5/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "OneOnOneTalkingPointComment",
      "kind": "LinkedField",
      "name": "comments",
      "plural": true,
      "selections": [
        (v5/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdAt",
          "storageKey": null
        },
        (v18/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            (v7/*: any*/),
            (v19/*: any*/),
            (v20/*: any*/),
            (v5/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "completedAt",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "OneOnOneRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CheckinRelationship",
            "kind": "LinkedField",
            "name": "viewerUserRelationship",
            "plural": false,
            "selections": [
              {
                "args": [
                  {
                    "kind": "Variable",
                    "name": "hasNoMeetingId",
                    "variableName": "hasNoMeetingId"
                  },
                  (v4/*: any*/)
                ],
                "kind": "FragmentSpread",
                "name": "OneOnOne_checkinRelationship"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "OneOnOneRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CheckinRelationship",
            "kind": "LinkedField",
            "name": "viewerUserRelationship",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "viewerIsManager",
                "storageKey": null
              },
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isOneOnOneActive",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "report",
                "plural": false,
                "selections": (v8/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "manager",
                "plural": false,
                "selections": (v8/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1
                  },
                  {
                    "kind": "Literal",
                    "name": "pastOnly",
                    "value": true
                  }
                ],
                "concreteType": "checkinRelationshipOneOnOneMeetingsConnection",
                "kind": "LinkedField",
                "name": "oneOnOneMeetings",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "checkinRelationshipOneOnOneMeetingsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "OneOnOneMeeting",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          (v9/*: any*/),
                          (v5/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "oneOnOneMeetings(first:1,pastOnly:true)"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "nextRecurringOneOnOneMeeting",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  },
                  (v5/*: any*/),
                  (v9/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v6/*: any*/),
                      (v11/*: any*/),
                      (v12/*: any*/),
                      (v13/*: any*/),
                      (v14/*: any*/),
                      (v15/*: any*/),
                      (v16/*: any*/),
                      (v17/*: any*/),
                      (v21/*: any*/)
                    ],
                    "type": "OneOnOneMeeting",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "condition": "hasNoMeetingId",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                  {
                    "alias": null,
                    "args": [
                      (v4/*: any*/)
                    ],
                    "concreteType": "OneOnOneMeeting",
                    "kind": "LinkedField",
                    "name": "findOneOnOneMeeting",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      (v6/*: any*/),
                      (v11/*: any*/),
                      (v12/*: any*/),
                      (v5/*: any*/),
                      (v13/*: any*/),
                      (v14/*: any*/),
                      (v15/*: any*/),
                      (v16/*: any*/),
                      (v17/*: any*/),
                      (v21/*: any*/)
                    ],
                    "storageKey": null
                  }
                ]
              }
            ],
            "storageKey": null
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3cc6ecc23ee3c79aed4e60952d22fdaf",
    "id": null,
    "metadata": {},
    "name": "OneOnOneRefetchQuery",
    "operationKind": "query",
    "text": "query OneOnOneRefetchQuery(\n  $meetingId: String!\n  $userId: String!\n  $hasNoMeetingId: Boolean!\n) {\n  user(entityId: $userId) {\n    viewerUserRelationship {\n      ...OneOnOne_checkinRelationship_2NNiR7\n      id\n    }\n    id\n  }\n}\n\nfragment OneOnOneContent_checkinRelationship on CheckinRelationship {\n  id\n  viewerIsManager\n  report {\n    products {\n      oneOnOnes {\n        isEnabled\n      }\n    }\n    id\n  }\n  manager {\n    products {\n      oneOnOnes {\n        isEnabled\n      }\n    }\n    id\n  }\n}\n\nfragment OneOnOneContent_oneOnOne on OneOnOneMeeting {\n  previousOneOnOneMeeting {\n    entityId\n    id\n  }\n  nextOneOnOneMeeting {\n    entityId\n    id\n  }\n  id\n  entityId\n  scheduledAt\n  cancelledAt\n  reviewedAt\n  note\n  reportNote\n  viewerPrivateNote\n  talkingPoints {\n    id\n    body\n    entityId\n    creator {\n      avatarUrl\n      name\n      viewerIsUser\n      id\n    }\n    comments {\n      id\n      createdAt\n      body\n      user {\n        viewerIsUser\n        avatarUrl\n        name\n        id\n      }\n    }\n    completedAt\n  }\n}\n\nfragment OneOnOne_checkinRelationship_2NNiR7 on CheckinRelationship {\n  viewerIsManager\n  id\n  entityId\n  isOneOnOneActive\n  report {\n    preferredName\n    viewerIsUser\n    entityId\n    id\n  }\n  manager {\n    preferredName\n    viewerIsUser\n    entityId\n    id\n  }\n  oneOnOneMeetings(first: 1, pastOnly: true) {\n    edges {\n      node {\n        entityId\n        scheduledAt\n        id\n      }\n    }\n  }\n  findOneOnOneMeeting(meetingId: $meetingId) @skip(if: $hasNoMeetingId) {\n    scheduledAt\n    entityId\n    previousOneOnOneMeeting {\n      entityId\n      id\n    }\n    nextOneOnOneMeeting {\n      entityId\n      id\n    }\n    ...OneOnOneContent_oneOnOne\n    id\n  }\n  nextRecurringOneOnOneMeeting {\n    __typename\n    id\n    scheduledAt\n    ... on OneOnOneMeeting {\n      entityId\n      ...OneOnOneContent_oneOnOne\n    }\n  }\n  ...OneOnOneContent_checkinRelationship\n}\n"
  }
};
})();

(node as any).hash = "d423f3d09994ca215422db025609e39b";

export default node;
